<template>
  <div v-if="!product.specific.called">
    <p v-if="product.figures.underlyingPrice.useLast >= product.derived.nextObservation.strike">
      Bei einem unveränderten Basiswertkurs kommt es zu einer <span
      v-if="product.common.maturityDate != product.derived.nextObservation.date">vorzeitigen</span>
      Rückzahlung zum Nennbetrag von <span
      v-html="this.$options.filters.currency(product.specific.notional, 'EUR')"></span>
      zuzüglich einer Kuponzahlung in Höhe von <span
      v-html="this.$options.filters.percent(product.derived.nextCoupon.coupon)"></span> p.a.
      am <span v-html="this.$options.filters.date(product.derived.nextCoupon.payDate)"></span>.
    </p>
    <!-- unter strike aber nicht letzter bewertungstag -->
    <div v-if="product.common.maturityDate != product.derived.nextObservation.date">
      <p
        v-if="product.figures.underlyingPrice.useLast < product.derived.nextObservation.strike && (product.specific.barrierHit || product.figures.underlyingPrice.useLast < product.specific.barrier)">
        Bei einem unveränderten Basiswertkurs kommt es zu keiner vorzeitigen Rückzahlung
        und es droht am Laufzeitende ein Nennwertverlust. Die nächste Kuponzahlung in
        Höhe von <span v-html="this.$options.filters.percent(product.derived.nextCoupon.coupon)"></span> p.a.
        erfolgt am <span v-html="this.$options.filters.date(product.derived.nextCoupon.payDate)"></span>.
        <span v-if="product.specific.barrierHit">
                Die Kursschwelle von <span
          v-html="this.$options.filters.currency(product.specific.barrier, added.underlyingQuotedAs)"></span> wurde bereits berührt.
            </span>
        <span v-if="product.figures.underlyingPrice.useLast < product.specific.barrier">
                Die Kursschwelle von <span
          v-html="this.$options.filters.currency(product.specific.barrier, added.underlyingQuotedAs)"></span> wird bei unverändertem Basiswertkurs am Laufzeitende berührt sein.
            </span>
      </p>
      <p
        v-if="product.figures.underlyingPrice.useLast < product.derived.nextObservation.strike && !product.specific.barrierHit && product.figures.underlyingPrice.useLast > product.specific.barrier">
        Bei einem unveränderten Basiswertkurs kommt es zu keiner vorzeitigen Rückzahlung des Nennbetrags.
        Die nächste Kuponzahlung in Höhe von <span
        v-html="this.$options.filters.percent(product.derived.nextCoupon.coupon)"></span> p.a.
        erfolgt am <span v-html="this.$options.filters.date(product.derived.nextCoupon.payDate)"></span>. Die
        Kursschwelle von
        <span v-html="this.$options.filters.currency(product.specific.barrier, added.underlyingQuotedAs)"></span> wurde
        noch nicht berührt.
      </p>
    </div>
    <!-- unter strike und letzter bewertungstag -->
    <div v-if="product.common.maturityDate == product.derived.nextObservation.date">
      <p
        v-if="product.figures.underlyingPrice.useLast < product.derived.nextObservation.strike && (product.specific.barrierHit || product.figures.underlyingPrice.useLast < product.specific.barrier)">
        Bei einem unveränderten Basiswertkurs kommt es zur finalen Rückzahlung am Laufzeitende und es droht ein
        Nennwertverlust. Die nächste Kuponzahlung in Höhe von <span
        v-html="this.$options.filters.percent(product.derived.nextCoupon.coupon)"></span> p.a.
        erfolgt am <span v-html="this.$options.filters.date(product.derived.nextCoupon.payDate)"></span>.
        <span v-if="product.specific.barrierHit">
                Die Kursschwelle von <span
          v-html="this.$options.filters.currency(product.specific.barrier, added.underlyingQuotedAs)"></span> wurde bereits berührt.
            </span>
        <span v-if="product.figures.underlyingPrice.useLast < product.specific.barrier">
                Die Kursschwelle von <span
          v-html="this.$options.filters.currency(product.specific.barrier, added.underlyingQuotedAs)"></span> wird bei unverändertem Basiswertkurs berührt sein.
            </span>
      </p>
      <p
        v-if="product.figures.underlyingPrice.useLast < product.derived.nextObservation.strike && !product.specific.barrierHit && product.figures.underlyingPrice.useLast > product.specific.barrier">
        Bei einem unveränderten Basiswertkurs kommt es zu einer Rückzahlung zum Nennbetrag von <span
        v-html="this.$options.filters.currency(product.specific.notional, 'EUR')"></span>
        zuzüglich einer Kuponzahlung in Höhe von <span
        v-html="this.$options.filters.currency(product.derived.nextCoupon.coupon, 'EUR')"></span> p.a.
        am <span v-html="this.$options.filters.date(product.derived.nextCoupon.payDate)"></span>.
        Die Kursschwelle von <span
        v-html="this.$options.filters.currency(product.specific.barrier, added.underlyingQuotedAs)"></span> wurde noch
        nicht berührt.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payback-fix-kupon',
  props: {
    product: {
      type: Object,
      required: true
    },
    added: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaybackFixKupon.vue?c3145390